import React, { useContext, useState, useMemo, useCallback } from "react";

import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { Row } from "reactstrap";
import TableSimple from "../../../components/Dynamic/TableSimple";
import { DF_OT0055Context } from "../context";
import BizinBackend from "../../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import NotificationModal from "../../../components/Common/NotificationModal";
import ModalIframePage from "../../../components/Common/ModalIframePage";

function GridBody() {
  const { access_token } = useSelector((state) => ({
    access_token: state.login.user.access_token,
  }));

  const csrfToken = useGetCsrfToken();
  const [preFilter, setPreFilter] = useState([]);
  const [selectedIds, setSelectedIds] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [triggerType, setTriggerType] = useState(null);
  const [openModalVisualization, setOpenModalVisualization] = useState(false);
  const {
    userProfile,
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    setParamsOnFilter,
    navigate,
  } = useContext(DF_OT0055Context);

  const verifyDelete = useCallback(
    async (idLocalEntrega, idLocalDesembarque) => {
      try {
        const response = await BizinBackend.executeProcedure(
          {
            1: idLocalEntrega,
            2: idLocalDesembarque,
          },
          "SRM_Agendamento_Verifica_Agendamento",
          csrfToken,
          access_token,
        );

        if (Array.isArray(response) && response.length > 0) {
          setBlocked(true);
        } else {
          setBlocked(false);
        }

        setShowDeleteModal(true);
      } catch (error) {
        console.error(error);
      }
    },
    [csrfToken, access_token],
  );

  const handleCloseModalVisualization = useCallback(
    (reload = false) => {
      setOpenModalVisualization(false);
      setTriggerType(null);

      if (reload) {
        setTriggerOnFilter(true);
      }
    },
    [setTriggerOnFilter],
  );

  const handleConfirm = useCallback(async () => {
    try {
      await BizinBackend.executeProcedure(
        {
          1: selectedIds.idLocalDesembarque,
        },
        "SRM_Agendamento_Cancela_Local_Desembarque",
        csrfToken,
        access_token,
      );

      setShowDeleteModal(false);
      setShowSuccessModal(true);
    } catch (error) {
      console.error(error);
    }
  }, [selectedIds, csrfToken, access_token]);

  const handleTriggers = useCallback(
    (trigger) => {
      const transactionId = trigger.transaction_id || "";

      if (transactionId.endsWith("/DF_OT0057")) {
        const params = trigger.params || "";

        const idLocalEntrega = params.match(/ID_Local_Entrega=(\d+)/)?.[1];

        const idLocalDesembarque = params.match(
          /ID_Local_Desembarque=(\d+)/,
        )?.[1];

        setSelectedIds({
          idLocalEntrega: Number(idLocalEntrega),
          idLocalDesembarque: Number(idLocalDesembarque),
        });

        verifyDelete(Number(idLocalEntrega), Number(idLocalDesembarque));

        return;
      }

      // Visualizar e Editar
      setTriggerType(trigger);
      setOpenModalVisualization(true);
    },
    [verifyDelete],
  );

  const columnsList = useMemo(
    () => [
      {
        field: "ID_Local_Entrega",
        header: "ID",
        width: "8%",
        sort: true,
      },
      {
        field: "Descricao_Local_Entrega",
        header: "Local de Entrega",
        sort: true,
      },
      {
        field: "Descricao_Entrega",
        header: "Descrição",
        sort: true,
      },
      {
        field: "Coluna_Funcoes",
        header: "",
        width: "8%",
        hasImage: true,
        Export: false,
      },
    ],
    [],
  );

  return (
    <React.Fragment>
      <div className="bg-white mb-3 card-content shadow-card p-3">
        <div className="row align-items-end gx-3">
          <div className="col-lg-5 col-md-12">
            <TranspaleStringToComponente
              elementId="ID_Empresa"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Empresa",
                id: "Filtro_ID_Empresa",
                isDisabled: false,
                procedure: "SRM_Agendamento_Get_Empresas",
                procedureParams: [userProfile?.ID_Usuario],
              }}
              preFilter={preFilter}
              onPreFilter={(filters) => {
                setPreFilter((state) => [
                  {
                    ...state[0],
                    ...filters,
                  },
                ]);
              }}
            />
          </div>

          <div className="col-lg-5 col-md-12">
            <TranspaleStringToComponente
              elementId="ID_Local_Entrega"
              elementProps={{
                value: "",
                type: "Combobox",
                title: "Local de Entrega",
                id: "Filtro_ID_Local_Entrega",
                isDisabled: false,
                procedure: "SRM_Agendamento_Local_Entrega",
                procedureParams: [
                  String(userProfile?.ID_Usuario),
                  "<#Filtro_ID_Empresa#>",
                ],
                alienated: ["Filtro_ID_Empresa"],
              }}
              preFilter={preFilter}
              onPreFilter={(filters) =>
                setPreFilter((state) => [{ ...state[0], ...filters }])
              }
            />
          </div>

          <div className="col-lg-2 col-md-12">
            <div className="d-flex justify-content-end align-items-end gap-2 h-100 pb-3">
              <button
                type="button"
                className="btn btn-primary-dark text-white fw-semibold"
                onClick={() => {
                  setParamsOnFilter(preFilter);
                  setTriggerOnFilter(true);
                }}
              >
                Pesquisar
              </button>

              <button
                type="button"
                className="btn btn-primary-dark text-white fw-semibold"
                onClick={() => {
                  const idEmpresa = preFilter?.[0]?.Filtro_ID_Empresa?.value;
                  const idLocalEntrega =
                    preFilter?.[0]?.Filtro_ID_Local_Entrega?.value;

                  if (!idEmpresa || !idLocalEntrega) {
                    console.warn(
                      "Selecione a Empresa e o Local de Entrega antes de cadastrar.",
                    );
                    return;
                  }

                  navigate("/DF_OT0056", {
                    state: {
                      idEmpresa,
                      idLocalEntrega,
                    },
                  });
                }}
              >
                Novo
              </button>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <TableSimple
          dataKey={"ID"}
          procName={"FRONT_Workspace_DF_OT0055_Tabela_Grid_V16"}
          procParams={`[
            "${userProfile?.ID_Usuario || 0}",
            "pt-BR",
            "1",
            "10",
            "<#Filtro_ID_Empresa#>"
          ]`}
          columnsList={columnsList}
          paramsOnFilter={paramsOnFilter}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          callbackTriggers={handleTriggers}
        />
      </Row>

      <NotificationModal
        isOpen={showDeleteModal}
        type="warning"
        titleCustom={
          blocked
            ? "Não é possível excluir este Local de Desembarque."
            : "Deseja excluir o Local de Desembarque?"
        }
        message={
          blocked
            ? "Existem agendamentos vinculados a este Local de Desembarque."
            : 'Ao clicar em "Confirmar", o Local de Desembarque será excluído.'
        }
        confirmButton={!blocked}
        onConfirm={handleConfirm}
        onClose={() => setShowDeleteModal(false)}
      />

      <NotificationModal
        isOpen={showSuccessModal}
        type="success"
        message="Local de Desembarque excluído com sucesso!"
        onClose={() => {
          setShowSuccessModal(false);
          setTriggerOnFilter(true);
        }}
      />
      <ModalIframePage
        openModal={openModalVisualization}
        onClosed={handleCloseModalVisualization}
        triggerType={triggerType}
      />
    </React.Fragment>
  );
}

export default GridBody;
